import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "tab-name"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "tab-name"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.route == null)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([_ctx.tabName ? 'tab-item' : 'wbtn theme-svg', { 'accent-svg': _ctx.isSelected && !_ctx.tabName, 'active-tab-item': _ctx.isSelected && _ctx.tabName, disabled: _ctx.isDisabled }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click')))
      }, [
        (!_ctx.tabName)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: this.getIconPath(this.icon)
            }, null, 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.tabName), 1))
      ], 2))
    : (_openBlock(), _createBlock(_component_router_link, {
        key: 1,
        to: {name: _ctx.route},
        class: _normalizeClass(_ctx.tabName ? 'tab-item' : 'wbtn theme-svg'),
        "active-class": _ctx.tabName ? 'active-tab-item' : 'accent-svg'
      }, {
        default: _withCtx(() => [
          (!_ctx.tabName)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: _normalizeClass(_ctx.isBoldIcon ? 'bold-icon' : ''),
                src: this.getIconPath(this.icon)
              }, null, 10, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.tabName), 1))
        ]),
        _: 1
      }, 8, ["to", "class", "active-class"]))
}